import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { endpointStub } from '../../../../../mocks/utils';
import { FiltersState, MapData } from '../../../../model/global';
import queryString from 'query-string';

const queryBuilder = (filters: FiltersState, endpoint: string, mapSettings: MapData['settings']): string => {
	const cleanedFilters = {
		lat: filters.suggestedInput.lat === -1 ? undefined : filters.suggestedInput.lat,
		lng: filters.suggestedInput.lng === -1 ? undefined : filters.suggestedInput.lng,
		selectedCategories: filters.selectedPartnerCategories,
		distanceRadiusInKm: filters.distanceRadiusInKm,
		defaultCenterLat: mapSettings.defaultCenter.lat === -1 ? undefined : mapSettings.defaultCenter.lat,
		defaultCenterLng: mapSettings.defaultCenter.lng === -1 ? undefined : mapSettings.defaultCenter.lng,
	};

	const stringifiedQuery = queryString.stringify(cleanedFilters, { arrayFormat: 'comma' });

	const builtQuery = endpoint + '?' + stringifiedQuery;
	return builtQuery;
};

export const searchPartnersApi = createApi({
	reducerPath: 'searchPartnersApi',
	baseQuery: fetchBaseQuery({ baseUrl: endpointStub }),
	endpoints: (builder) => ({
		getPartners: builder.query({
			query: ({ filters, endpoint, mapSettings }) => queryBuilder(filters, endpoint, mapSettings),
		}),
		getLocationSuggestion: builder.query({
			query: ({ value, endpoint }) => endpoint + '?text=' + value,
		}),
		getPartnerProfile: builder.query({
			query: ({ value, endpoint }) => endpoint + '?id=' + value,
		}),
	}),
});

// Hooks are auto-generated based on the defined endpoints
export const { useGetPartnersQuery, useGetLocationSuggestionQuery, useGetPartnerProfileQuery } = searchPartnersApi;
